import { createFileRoute, useRouterState } from '@tanstack/react-router'

import LoginPage from '@/features/Auth/Login'
import type { LoginRedirectReason } from '@/features/Auth/Login/Types/types.ts'
import { RouteErrorComponent } from '@/shared/RouteErrorComponent/RouteErrorComponent.tsx'

function getLoginRedirectReason(hash: string): LoginRedirectReason | undefined {
    const reason = hash.replace(/^#/, '')

    if (
        reason === 'password-reset-token-missing' ||
        reason === 'password-reset-token-invalid'
    ) {
        return reason
    }

    return undefined
}

export const Route = createFileRoute('/_public/login')({
    component: RouteComponent,
    onError: RouteErrorComponent,
})

function RouteComponent() {
    const hash = useRouterState({
        select: (state) => state.location.hash,
    })

    return <LoginPage redirectReason={getLoginRedirectReason(hash)} />
}
